"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeTicketHistory = exports.ticketHistorySlice = exports.toggleTicketHistory = exports.fetchTicketHistory = void 0;
const pulse_components_1 = require("@pcs/pulse-components");
const toolkit_1 = require("@reduxjs/toolkit");
const utilities_1 = __importDefault(require("jsAssets/utilities"));
const assetDetailSlice_1 = require("./assetDetailSlice");
const initialTicketHistoryState = {
    data: undefined,
    isFetchingTicketHistory: false,
    showTicketHistoryPanel: false,
};
exports.fetchTicketHistory = (0, toolkit_1.createAsyncThunk)('ticket/fetchHistory', async (ticketId) => {
    if (!ticketId) {
        throw new Error('Failed to fetch ticket history. Please provide a valid ticket id.');
    }
    const params = {
        action: 'tasks',
        type: 'task-history',
        taskId: ticketId,
    };
    return pulse_components_1.v2Endpoint
        .get(`${window.pulse.config.urls.api}`, { params })
        .then((res) => {
        if (!res.data.success) {
            throw new Error(res.data.errorMessages);
        }
        return res.data.data.map((taskHistory) => taskHistory.history);
    })
        .catch(() => {
        utilities_1.default.notification.danger('Failed to fetch ticket history');
    });
});
exports.toggleTicketHistory = (0, toolkit_1.createAsyncThunk)('ticket/toggleHistory', (ticketId, { dispatch, getState, fulfillWithValue }) => {
    var _a;
    const { assetDetail: { asset, isOpenAdvanceDetails }, } = getState();
    const taskId = (_a = asset === null || asset === void 0 ? void 0 : asset.note) === null || _a === void 0 ? void 0 : _a.ticketid;
    if (!taskId) {
        utilities_1.default.dismissNotifications();
        utilities_1.default.notification.danger('The ticket have been updated failed');
        return;
    }
    if (isOpenAdvanceDetails) {
        dispatch((0, assetDetailSlice_1.toggleAdvancedTicketDetails)());
    }
    fulfillWithValue(ticketId);
});
exports.ticketHistorySlice = (0, toolkit_1.createSlice)({
    name: 'AssetDetail',
    initialState: initialTicketHistoryState,
    reducers: {
        closeTicketHistory: (state) => {
            state.showTicketHistoryPanel = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(exports.fetchTicketHistory.pending, (state) => {
            state.isFetchingTicketHistory = true;
        });
        builder.addCase(exports.fetchTicketHistory.fulfilled, (state, action) => {
            state.isFetchingTicketHistory = false;
            state.data = action.payload;
        });
        builder.addCase(exports.fetchTicketHistory.rejected, (state) => {
            state.isFetchingTicketHistory = false;
            state.showTicketHistoryPanel = true;
        });
        builder.addCase(exports.toggleTicketHistory.fulfilled, (state, action) => {
            state.ticketId = action.payload;
            state.showTicketHistoryPanel = !state.showTicketHistoryPanel;
        });
    },
});
exports.closeTicketHistory = exports.ticketHistorySlice.actions.closeTicketHistory;
exports.default = exports.ticketHistorySlice.reducer;
